import Layout from "@/components/feature/Layout";
import PageHero from "@/components/feature/PageHero";
import { clinicInfo } from "@/mocks/site";
import AppointmentForm from "./components/AppointmentForm";

const bringItems = [
  "Any previous medical records or referral letters",
  "Imaging such as X-ray, MRI or CT scans, if available",
  "A list of your current medications",
  "Details of your symptoms and when they started",
];

export default function BookAppointment() {
  return (
    <Layout>
      <PageHero
        title="Book an Appointment"
        subtitle="Request a consultation with our orthopaedic and spine specialist. Share your details and our team will contact you to confirm a suitable time."
        crumbs={[{ label: "Home", to: "/" }, { label: "Book Appointment" }]}
      />

      <section className="bg-background-100 py-12 md:py-16">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 md:px-6 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-8">
            <AppointmentForm />
          </div>

          <aside className="lg:col-span-4">
            <div className="rounded-lg border border-background-200 bg-background-50 p-6">
              <h2 className="font-heading text-lg font-semibold text-foreground-950">Prefer to call?</h2>
              <p className="mt-2 font-body text-sm leading-relaxed text-foreground-600">
                Our team is happy to help you find a convenient appointment time.
              </p>
              <a
                href={clinicInfo.phoneHref}
                className="mt-4 flex items-center justify-center gap-2 rounded-md bg-primary-500 px-5 py-3 font-label text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-phone-fill" aria-hidden="true"></i>
                {clinicInfo.phoneDisplay}
              </a>
              <a
                href={clinicInfo.whatsappHref}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Chat with us on WhatsApp"
                className="mt-3 flex items-center justify-center gap-2 rounded-md border border-primary-300 px-5 py-3 font-label text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-50"
              >
                <i className="ri-whatsapp-line text-lg" aria-hidden="true"></i>
                Chat on WhatsApp
              </a>
              <div className="mt-5 space-y-3 border-t border-background-200 pt-5 font-body text-sm text-foreground-700">
                <p className="flex items-start gap-2.5">
                  <i className="ri-map-pin-line mt-0.5 text-primary-600" aria-hidden="true"></i>
                  {clinicInfo.addressFull}
                </p>
                {clinicInfo.hours.length ? (
                  <p className="flex items-start gap-2.5">
                    <i className="ri-time-line mt-0.5 text-primary-600" aria-hidden="true"></i>
                    <span>
                      {clinicInfo.hours.map((line) => (
                        <span key={line} className="block">
                          {line}
                        </span>
                      ))}
                    </span>
                  </p>
                ) : null}
              </div>
            </div>

            <div className="mt-5 rounded-lg border border-background-200 bg-background-50 p-6">
              <h2 className="font-heading text-lg font-semibold text-foreground-950">What to bring</h2>
              <ul className="mt-4 space-y-3">
                {bringItems.map((item) => (
                  <li key={item} className="flex items-start gap-3 font-body text-sm text-foreground-700">
                    <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-accent-100 text-accent-700">
                      <i className="ri-check-line text-xs" aria-hidden="true"></i>
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-5 rounded-lg border border-background-200 bg-secondary-50 p-6">
              <p className="font-body text-xs leading-relaxed text-secondary-900">
                <strong>Please note:</strong> Submitting this form is a request, not a confirmed appointment. Our team
                will contact you to confirm the date and time.
              </p>
            </div>
          </aside>
        </div>
      </section>
    </Layout>
  );
}